import React from "react";
import { whiteLogo } from "../icons/white-logo";
import { whatsapp } from "../icons/whatsapp";
import { facebook } from "../icons/facebook";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <div className=" w-full h-fit lg:h-[24rem]">
      <div className="bg-mobile-footer-background lg:bg-footer-background bg-cover bg-center h-full ">
        <div className=" text-white flex flex-col lg:flex-row py-10 lg:py-0 lg:justify-between lg:items-center  h-full px-20 ">
          <div className="flex flex-col lg:flex-row gap-20 lg:gap-44 text-xl lg:text-2xl">
            <div className="lg:flex flex-col hidden gap-10">
              <span className="mx-auto">{whiteLogo}</span>© Copyright Acts
            </div>
            <div className="flex flex-col gap-2 text-center">
              <span className="text-lg text-gray-400">القائمة</span>
              <Link to={"/home/cropsOffers"}>
                <span>المحاصيل</span>
              </Link>

              <Link to={"/home/services"}>
                <span>الخدمات</span>
              </Link>

              <Link to={"/home/prices"}>
                <span>الأسعار</span>
              </Link>

              <Link to={"/home/weather"}>
                <span>الطقس</span>
              </Link>

              <Link to={"/home/profile"}>
                <span>حسابي</span>
              </Link>
            </div>
            <div className="flex flex-col  gap-2 text-center">
              <Link to={"/home/about"}>
                <span>من نحن</span>
              </Link>
              <Link to={"/home/privacy-policy"}>
              <span>الخصوصية</span>
              </Link>
              <Link to={"/home/terms"}>
              <span>ضوابط الإستخدام</span>
              </Link>
              
            </div>
          </div>
          <div className="flex gap-3 flex-col items-center mt-20 lg:my-0 lg:items-end">
            <p className="text-center text-2xl"> إتصل بنا على الرقم المختصر</p>
            <a className="text-9xl" href="tel:3623">
              {" "}
              3623
            </a>
            <div className="text-2xl">
              <button
                onClick={() => (window.location = "mailto:info@mahsool.sd")}
              >
                info@mahsool.sd
              </button>
            </div>
            <div className="flex gap-3">
              <a href="https://wa.me/message/K5BD6QOI2BBYE1" target="_blank">
                <p className="p-3 bg-white/10 rounded-full hover:scale-105 hover:shadow-white hover:shadow-md transition-all">
                  {whatsapp}
                </p>
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=100089265053519&mibwxtid=ZbWKwL"
                target="_blank"
              >
                <p className="p-3 bg-white/10 rounded-full  hover:scale-105 hover:shadow-white hover:shadow-md transition-all">
                  {facebook}
                </p>
              </a>
            </div>
            <div className="flex flex-col mt-10 lg:hidden gap-10">
              <span className="mx-auto">{whiteLogo}</span>© Copyright Acts
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
